import React from 'react';
import { useGetDentalbyIdQuery } from '../../../store/api/contact';

function DetailModal({ onclose, isopen, medicalinfoId }) {
  // Fetch the data using RTK Query hook
  const { data, isLoading, isError } = useGetDentalbyIdQuery(medicalinfoId, {
    skip: !medicalinfoId,
  });

  if (!isopen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-lg p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Close button */}
        <button
          onClick={onclose}
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-lg"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">Dental Details</h2>

        {isLoading && <p className="text-gray-500">Loading...</p>}
        {isError && <p className="text-red-500">Failed to load data.</p>}

        {data && (
          <div className="space-y-3 text-sm text-gray-700">
            {/* Basic Info */}
            <section>
              <p><strong>Name:</strong> {data.full_name}</p>
              <p><strong>Phone:</strong> {data.phone_number}</p>
              <p><strong>Email:</strong> {data.email_address}</p>
              <p><strong>Date of Birth:</strong> {data.date_of_birth}</p>
              <p><strong>Status:</strong> {data.status}</p>
            </section>

            <hr className="my-2" />

            {/* Medical Details */}
            <section>
              <p><strong>Under Physician’s Care:</strong> {data.physicians_care}</p>
              {data.physicians_condition && (
                <p><strong>Physician’s Condition:</strong> {data.physicians_condition}</p>
              )}
              <p><strong>Taking Medications:</strong> {data.medications}</p>
              {data.medications_list && (
                <p><strong>Medications List:</strong> {data.medications_list}</p>
              )}
              <p><strong>Allergies:</strong> {data.allergies}</p>
            </section>

            <hr className="my-2" />

            {/* Dental Details */}
            <section>
              <p><strong>Last Dental Visit:</strong> {data.last_dental_visit}</p>
              <p><strong>Reason for Visit:</strong> {data.reason_for_visit}</p>
              <p><strong>Tobacco Use:</strong> {data.tobacco_use}</p>
              <p><strong>Mouthwash Use:</strong> {data.mouthwash_use}</p>
            </section>

            <hr className="my-2" />

            {/* Array Fields */}
            <section className="space-y-2">
              <p><strong>Conditions:</strong> {data.conditions?.length ? data.conditions.join(', ') : 'None'}</p>
              <p><strong>Symptoms:</strong> {data.symptoms?.length ? data.symptoms.join(', ') : 'None'}</p>
              <p><strong>Dental History:</strong> {data.dental_history?.length ? data.dental_history.join(', ') : 'None'}</p>
              <p><strong>Brushing Frequency:</strong> {data.brushing_frequency?.length ? data.brushing_frequency.join(', ') : 'None'}</p>
              <p><strong>Dentist Visit Frequency:</strong> {data.dentist_visit_frequency?.length ? data.dentist_visit_frequency.join(', ') : 'None'}</p>
            </section>

            <hr className="my-2" />

            {/* Other Info */}
            <section>
              <p><strong>Main Concerns:</strong> {data.main_concerns}</p>
              <p><strong>Oral Health Improvement:</strong> {data.oral_health_improvement}</p>
            </section>

            <hr className="my-2" />

            {/* Dates */}
            <section>
              <p>
                <strong>Created At:</strong>{' '}
                {new Date(data.created_at).toLocaleDateString('en-IN', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })}
              </p>
              <p>
                <strong>Updated At:</strong>{' '}
                {new Date(data.updated_at).toLocaleDateString('en-IN', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })}
              </p>
            </section>
          </div>
        )}
      </div>
    </div>
  );
}

export default DetailModal;
